import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { UserManagementRow } from '../user-management/user-management.component';


export type AgreementDuration = 'Limited' | 'Unlimited' | '';

export interface UserApprovalForm {
  targetUsers: UserManagementRow[];
  newState: string;
  agreementDuration: String;
  agreementType?: string;
  paymentStatus?: string;
  dueDate?: string;
  role?: string;
  country?: string;
  organizationName?: string;
  organizationType?: string;
  referenceLicense?: string;

  groups?: string[];
  systemRoles?: string[];
}

@Component({
  selector: 'app-user-approval',
  templateUrl: './user-approval.component.html',
  styleUrls: ['../../app.component.scss', 'user-approval.component.scss'],
  standalone: false
})
export class UserApprovalComponent implements OnInit {

  @Input() users: UserManagementRow[] = [];
  availableTargetStates: { label: string, value: string }[] = [];

  @Output() confirm = new EventEmitter<UserApprovalForm>();

  modalTitle = 'Manage User';

  private todayStr: string;

  agreementDurationOptions: AgreementDuration[] = ['Limited', 'Unlimited'];
  agreementTypeOptions: string[] = ['Free', 'Partial UPP', 'Full UPP'];

  groupsText: string = '';

  availableSystemRoles: { value: string; label: string }[] = [
  {
    value: 'ApprovingEntity',
    label: 'Approving entity (National Radio Regulator)'
  },
  {
    value: 'FullUser',
    label: 'Full user (ANSP, MAA, CAA, Military, Police)'
  },
  {
    value: 'ReducedUser',
    label: 'Reduced user (CAU, MAU, MoD, AO, NM, GNSS SC, Other)'
  }
];

  organizationTypes: string[] = ['Customer', 'Partner', 'Internal'];
  colapsableLabelUsersList: boolean = false;
  colapsableDivUsersList: boolean = false;
  colapsableLabelEditableFields: boolean = false;
  colapsableDivEditableFields: boolean = false;

  // Current state info
  currentState: string = '';
  currentAgreementDuration: string = '';
  currentAgreementType: string = '';
  currentPaymentStatus: string = '';
  currentDueDate: string = '';
  currentReferenceLicense: string = '';

  form: UserApprovalForm = {
    targetUsers: [],
    newState: 'Approved',
    agreementDuration: '',
    agreementType: '',
    paymentStatus: '',
    dueDate: '',
    role: '',
    country: '',
    organizationName: '',
    organizationType: '',
    referenceLicense: '',
    groups: [],
    systemRoles: []

  };

  constructor(
    public bsModalRef : BsModalRef,
    public bsModalService: BsModalService,
    private modalControlService: ModalControlService,
    private modalConfirmationService: ModalConfirmationService
  ) {
    this.todayStr = this.toDateInputValue(new Date());
  }

  ngOnInit(): void {
    const firstUser = this.users && this.users.length > 0 ? this.users[0] : undefined;
    this.form = {
      targetUsers: this.users,
      newState: '',
      agreementDuration: firstUser?.agreementDuration ?? null,
      agreementType: firstUser?.agreementType ?? '',
      paymentStatus: firstUser?.paymentStatus ?? null,
      //dueDate: firstUser?.dueDate ?? '',
      dueDate: this.normalizeDateInputValue(firstUser?.dueDate),

      role: firstUser?.role ?? null,
      country: firstUser?.country ?? null,
      organizationName: firstUser?.organizationName ?? null,
      organizationType: firstUser?.organizationType ?? null,
      referenceLicense: firstUser?.referenceLicense ?? null,
      groups: firstUser?.groups ?? [],
      systemRoles: firstUser?.systemRoles ?? []

    };

    this.groupsText = (firstUser?.groups ?? []).join('\n');


    this.currentState = firstUser?.userState || '';
    this.currentAgreementDuration = firstUser?.agreementDuration || '';
    this.currentAgreementType = firstUser?.agreementType || '';
    this.currentPaymentStatus = firstUser?.paymentStatus || '';
    //this.currentDueDate = firstUser?.dueDate || '';
    this.currentDueDate = this.normalizeDateInputValue(firstUser?.dueDate);
    this.currentReferenceLicense = firstUser?.referenceLicense || '';

    if (this.users.length === 1 && firstUser) {
      this.modalTitle = 'Edit User';
      this.colapsableLabelUsersList = true;
      this.colapsableDivUsersList = true;
      this.colapsableLabelEditableFields = true;
      this.colapsableDivEditableFields = true;
    } else {
      this.modalTitle = `Edit Users`;
      this.colapsableLabelUsersList = false;
      this.colapsableDivUsersList = false;
      this.colapsableLabelEditableFields = false;
      this.colapsableDivEditableFields = false;
    }

    this.availableTargetStates = this.getAllowedTargetStates(this.currentState);
  }

  private toDateInputValue(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  toggleUsersTable(): void {
    this.colapsableLabelUsersList = !this.colapsableLabelUsersList;
    this.colapsableDivUsersList = !this.colapsableDivUsersList;
  }

  toggleEditableFields(): void {
    this.colapsableLabelEditableFields = !this.colapsableLabelEditableFields;
    this.colapsableDivEditableFields = !this.colapsableDivEditableFields;
  }

  getStateBadgeClass(): string {
    switch(this.currentState) {
      case 'Approved': return 'badge-approved';
      case 'Pending': return 'badge-pending';
      case 'Revoked': return 'badge-revoked';
      default: return 'badge-default';
    }
  }

  isCurrentlyApproved(): boolean {
    return this.currentState === 'Approved';
  }

  isCurrentlyPending(): boolean {
    return this.currentState === 'Pending';
  }


  onAgreementDurationChange(type: AgreementDuration): void {
    this.form.agreementDuration = type;
    if (type === 'Unlimited') {
      this.form.dueDate = '';
    }
  }

    onStateChange(newState: string): void {
    this.form.newState = newState;
    const firstUser = this.users && this.users.length > 0 ? this.users[0] : undefined;

    if (!newState || newState === 'Deleted') { // '-- Keep current state --' or 'Deleted'
     this.form.agreementDuration = firstUser?.agreementDuration ?? null;
      //this.form.dueDate = firstUser?.dueDate ?? '';
      this.form.dueDate = this.normalizeDateInputValue(firstUser?.dueDate);
      if(firstUser.userState === 'Revoke' || firstUser.userState === 'Pending') {
        this.form.agreementType = firstUser?.agreementType ?? '';
        this.form.paymentStatus = firstUser?.paymentStatus ?? null;

      }
      return;
    }

    if (newState === 'Approved') {
      if (!this.form.agreementDuration) {
        this.form.agreementDuration = 'Limited';
      }
      if (this.form.agreementDuration === 'Limited' && !this.form.dueDate) {
        this.form.dueDate = this.todayStr;
      }
    }

    if (newState === 'ApprovedAdmin') {
      this.form.agreementDuration = 'Unlimited';
      this.form.dueDate = '';
    }



  }

  setDueDateMonths(months: number): void {
    if (this.form.agreementDuration === 'Unlimited') {
      return;
    }

    const base = this.parseCurrentDueDateOrToday();
    base.setMonth(base.getMonth() + months);
    this.form.dueDate = this.toDateInputValue(base);
  }

  setDueDateYears(years: number): void {
    if (this.form.agreementDuration === 'Unlimited') {
      return;
    }

    const base = this.parseCurrentDueDateOrToday();
    base.setFullYear(base.getFullYear() + years);
    this.form.dueDate = this.toDateInputValue(base);
  }
  resetDueDate(): void {
    if (this.form.agreementDuration === 'Limited' && this.form.newState === 'Approved') {
      this.form.dueDate = this.todayStr;
    }
  }
  private parseCurrentDueDateOrToday(): Date {
    if (this.form.dueDate) {
      const [y, m, d] = this.form.dueDate.split('-').map(Number);
      if (y && m && d) {
        return new Date(y, m - 1, d);
      }
    }
    return new Date();
  }

  isFormChanged(): boolean {
  const firstUser = this.users && this.users.length > 0 ? this.users[0] : undefined;
  if (!firstUser) return false;
  // Se newState está vazio, considera o valor original
  const effectiveNewState = this.form.newState === '' ? firstUser.userState : this.form.newState;
  // Normaliza referenceLicense para comparar null, undefined e '' como equivalentes
  const normalize = (v: any) => (v === null || v === undefined) ? '' : v;
  return (
    effectiveNewState !== firstUser.userState ||
    normalize(this.form.dueDate) !== normalize(this.normalizeDateInputValue(firstUser.dueDate))||

    normalize(this.form.role) !== normalize(firstUser.role)||
    normalize(this.form.agreementDuration) !== normalize(firstUser.agreementDuration) ||
    normalize(this.form.agreementType) !== normalize(firstUser.agreementType) ||
    normalize(this.form.paymentStatus) !== normalize(firstUser.paymentStatus) ||
    normalize(this.form.country) !== normalize(firstUser.country) ||
    normalize(this.form.organizationName) !== normalize(firstUser.organizationName) ||
    normalize(this.form.organizationType) !== normalize(firstUser.organizationType) ||
    normalize(this.form.referenceLicense) !== normalize(firstUser.referenceLicense) ||
    this.normalizeArray(this.groupsText.split('\n').map(x => x.trim()).filter(x => !!x)) !== this.normalizeArray(firstUser.groups) ||
    this.normalizeArray(this.form.systemRoles) !== this.normalizeArray(firstUser.systemRoles)
  );
}

  submit(): void {
    // Não obriga a selecionar novo state

    if (this.form.newState === 'Approved' && !this.form.agreementType) {
    this.modalControlService.showMesssageModal(
      this.modalTitle,
      'Please select an agreement type.'
    );
    return;
  }

    if (this.form.agreementDuration === 'Limited') {
      if (!this.form.dueDate) {
        this.modalControlService.showMesssageModal(
          this.modalTitle,
          'Please select a due date for a limited license.'
        );
        return;
      }
    }

    const parsedGroups = this.groupsText
  .split('\n')
  .map(x => x.trim())
  .filter(x => !!x);

    // Envia todos os campos do formulário, sempre
    const fullForm: UserApprovalForm = {
      targetUsers: this.form.targetUsers,
      newState: this.form.newState,
      agreementDuration: this.form.agreementDuration,
      agreementType: this.form.agreementType,
      paymentStatus: this.form.paymentStatus,
      dueDate: this.form.dueDate,
      role: this.form.role,
      country: this.form.country,
      organizationName: this.form.organizationName,
      organizationType: this.form.organizationType,
      referenceLicense: this.form.referenceLicense,
      groups: parsedGroups,
      systemRoles: this.form.systemRoles ?? []
    };

    if (this.form.newState === 'Deleted') {
      this.modalConfirmationService.showMesssageConfirmationModal(
        'Confirm Deletion',
        'This action is irreversible. Do you wish to continue?',
        'Yes',
        'Cancel',
        () => {
          this.confirm.emit(fullForm);
          this.bsModalRef.hide();
        },
        () => {
        }
      );
    } else {
      this.confirm.emit(fullForm);
      this.bsModalRef.hide();
    }
  }

  private getAllowedTargetStates(state: string | undefined | null): { label: string, value: string }[] {
    switch (state) {
      case 'Pending':
        return [
          { label: 'Approved', value: 'Approved' },
          { label: 'Approved (Admin)', value: 'ApprovedAdmin' },
          { label: 'Deleted', value: 'Deleted' }
        ];
      case 'Approved':
        return [
          { label: 'Revoked', value: 'Revoked' },
          { label: 'Deleted', value: 'Deleted' }
        ];
      case 'Revoked':
        return [
          { label: 'Approved', value: 'Approved' },
          { label: 'Deleted', value: 'Deleted' }
        ];
      case 'Admin':
        return [
          { label: 'Deleted', value: 'Deleted' }
        ];
      default:
        return [];
    }
  }


  private normalizeDateInputValue(value?: string | null): string {
    if (!value) return '';

    // If already yyyy-MM-dd
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }

    const date = new Date(value);
    if (isNaN(date.getTime())) return '';

  return this.toDateInputValue(date);
}

  isSystemRoleSelected(roleName: string): boolean {
    return (this.form.systemRoles ?? []).includes(roleName);
  }

  onSystemRoleToggle(roleName: string, checked: boolean): void {
    const current = this.form.systemRoles ?? [];

    if (checked) {
      if (!current.includes(roleName)) {
        this.form.systemRoles = [...current, roleName];
      }
    } else {
      this.form.systemRoles = current.filter(r => r !== roleName);
    }
    this.syncGroupsFromSystemRoles();
  }

  private normalizeArray(arr?: any[]): string {
    return JSON.stringify((arr ?? []).slice().sort());
  }

private normalizeOrgType(orgType: string): string {
  return orgType.replace(/[^a-zA-Z0-9]/g, '');
}
 private getCountryBaseGroup(): string {
  const groups = this.groupsText
    .split('\n')
    .map(x => x.trim())
    .filter(x => !!x);

  const firstGroup = groups[0];

  if (!firstGroup) {
    return '';
  }

  return firstGroup
    .split('/')
    .filter(x => !!x)[0] || '';
}

private buildGroup(roleName: string): string {
  const country = this.getCountryBaseGroup();

   const orgType = this.normalizeOrgType(
    this.form.organizationType ?? ''
  );
  if (!country || !orgType) {
    return '';
  }

  return `/${country}/${roleName}/${orgType}/`;
}
  public syncGroupsFromSystemRoles(): void {
  const country = this.getCountryBaseGroup();
  if (!country) {
    return;
  }

  const roleGroups = (this.form.systemRoles ?? [])
    .map(role => this.buildGroup(role))
    .filter(g => !!g);

  this.groupsText = roleGroups.length > 0
    ? roleGroups.join('\n')
    : `/${country}/`;
}
}
